module.exports = __webpack_public_path__ + "img/image18@2x.59567326.png";